import { render } from "./Invite.vue?vue&type=template&id=0a4c6428&bindings={\"code\":\"props\",\"copiedToClipboard\":\"data\",\"hoveringCopy\":\"data\",\"loading\":\"data\",\"error\":\"data\",\"data\":\"data\",\"inviteFound\":\"data\",\"baseApiUrl\":\"data\",\"inviteYear\":\"options\",\"isMobile\":\"options\",\"fetchInvite\":\"options\",\"fetchDownload\":\"options\"}"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script